// Not including the following "control characters": \x0B\x0C
export const regexpLineBreaks = new RegExp(/[\r\n\u0085\u2028\u2029]+/, 'g');

export function filterLineBreaks(value: string) {
    return value.replace(regexpLineBreaks, ' ');
}
